<template>
    <div v-show="activeBackDrop"
         class="modal scrol-custom fade" :id="id"
         aria-modal="true"
         :data-backdrop="activeBackDrop ? 'static' : true"
         :data-keyboard="!activeBackDrop"
         style="display: none; border-radius: 0;"
    >
        <div class=" modal-dialog modal-dialog-centered modal-dialog-scrollable"
             :class="{'modal-sm': size === 'small', 'modal-lg': size === 'large', 'modal-xl ml-5 mr-5': size === 'extra-large'}">
            <div
                class="modal-content"
                style="border-radius: 20px;"
                :style="{'height': fixedHeight ? '100vh' : 'auto' }"
            >
                <div v-if="title !== ''" class="modal-header"
                     style="background-color: #393982; color: white; padding-bottom: 10px; padding-top: 10px;">
                    <h4 class="modal-title"
                        style="font-size: 14pt; font-weight: bold; text-transform: uppercase; color: white; margin: 0 !important;">
                        {{ title }}</h4>
                    <span class="fa fa-times fa-3x text-danger m-action" @click="hide('closeModalX')"></span>
                </div>
                <div class="modal-body scrol-custom" :class="{'p-0': !padding}">
                    <slot></slot>
                </div>
                <div v-if="showFooter" class="modal-footer justify-content-between">
                    <slot name="actions"/>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
export default {
    props: {
        activeBackDrop: {
            type: Boolean,
            default: false
        },
        isShow: {
            type: Boolean,
            default: false
        },
        padding: {
            type: Boolean,
            default: true
        },
        id: {
            type: Number
        },
        title: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: ""
        },
        showFooter: {
            type: Boolean,
            default: true
        },
        fixedHeight: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        isShow(val) {
            if (val) {
                this.show()
            } else {
                this.hide();
            }
        }
    },
    methods: {
        show() {
            $(this.$el).modal("show");
        },
        hide(event = null) {
            $(this.$el).modal("hide");
            setTimeout(() => {
                this.$emit('closeModal')
                if (event){
                    this.$emit(event)
                }
            }, 500)
        },
    }
};
</script>
<style scoped>
@media (min-width: 1200px) {
    .modal-xl {
        max-width: 100%;
    }

    .modal-xl .modal-content {
        height: 95vh
    }
}

@media (min-width: 738px) {
    .modal-xl {
        max-width: 100%;
    }

    .modal-xl .modal-content {
        height: 95vh
    }
}


</style>
